import { createStore } from 'vuex';
import { mutations } from './mutations';
import { actions } from './actions';
import { getters } from './getters';
import createPersistedState from "vuex-persistedstate";
import appConfiguration from '../../package.json';

const store = createStore({
  state() {
    return {
      yearList: undefined,
      electionList: undefined,
      contestList: undefined,
      contest: undefined,
      year: undefined,
      election: undefined,
      candidateStatementInfo: {},
      search: null,
      appVersion: appConfiguration.version
    };
  },
  actions,
  mutations,
  getters,
  plugins: [createPersistedState()]
});

export default store;
